// EV6...............................................
import cardimg1 from "../../Assets/EV9/2024_03_28_rrg_kia_newcar_trim_ev9_gt_line 1.png";
import cardicon1 from "../../Assets/Images/time-min.png";
import cardicon2 from "../../Assets/Images/chargers available-min.png";
import cardicon3 from "../../Assets/Images/charger-min.png";
// EV9.......................
import oceanblue1 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094718-removebg-preview.png";
import oceanblue2 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094755-removebg-preview.png";
import oceanblue3 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094814-removebg-preview.png";
import oceanblue4 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094832-removebg-preview.png";
import oceanblue5 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094854-removebg-preview.png";
import oceanblue6 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094908-removebg-preview.png";
import oceanblue7 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094925-removebg-preview.png";
import oceanblue8 from "../../Assets/EV9/Ocean Blue Matte/Screenshot_2024-05-27_094938-removebg-preview.png";

import snowwhite1 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092048-removebg-preview.png";
import snowwhite2 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092120-removebg-preview.png";
import snowwhite3 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092138-removebg-preview.png";
import snowwhite4 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092300-removebg-preview.png";
import snowwhite5 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092244-removebg-preview.png";
import snowwhite6 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092216-removebg-preview.png";
import snowwhite7 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092300-removebg-preview.png";
import snowwhite8 from "../../Assets/EV9/Snow White Pearl/Screenshot_2024-05-27_092325-removebg-preview.png";
import puplegray1 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091616-removebg-preview.png";
import puplegray2 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091659-removebg-preview.png";
import puplegray3 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091724-removebg-preview.png";
import puplegray4 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091803-removebg-preview.png";
import puplegray5 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091842-removebg-preview.png";
import puplegray6 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091906-removebg-preview.png";
import puplegray7 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091926-removebg-preview.png";
import puplegray8 from "../../Assets/EV9/Pebble Gray/Screenshot_2024-05-27_091952-removebg-preview.png";
import icegreen1 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093648-removebg-preview.png";
import icegreen2 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093722-removebg-preview.png";
import icegreen3 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093740-removebg-preview.png";
import icegreen4 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093802-removebg-preview.png";
import icegreen5 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093822-removebg-preview.png";
import icegreen6 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093927-removebg-preview.png";
import icegreen7 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_093947-removebg-preview.png";
import icegreen8 from "../../Assets/EV9/Iceberg Green/Screenshot_2024-05-27_094012-removebg-preview.png";
import silvermatte1 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094417-removebg-preview.png";
import silvermatte2 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094435-removebg-preview.png";
import silvermatte3 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094449-removebg-preview.png";
import silvermatte4 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094509-removebg-preview.png";
import silvermatte5 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094529-removebg-preview.png";
import silvermatte6 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094544-removebg-preview.png";
import silvermatte7 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094601-removebg-preview.png";
import silvermatte8 from "../../Assets/EV9/Ivory Silver Matte/Screenshot_2024-05-27_094613-removebg-preview.png";
import arorablack1 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092446-removebg-preview.png";
import arorablack2 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092531-removebg-preview.png";
import arorablack3 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092549-removebg-preview.png";
import arorablack4 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092614-removebg-preview.png";
import arorablack5 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092633-removebg-preview.png";
import arorablack6 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092700-removebg-preview.png";
import arorablack7 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092720-removebg-preview.png";
import arorablack8 from "../../Assets/EV9/Aurora Black Pearl/Screenshot_2024-05-27_092736-removebg-preview.png";
import patherametal1 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093239-removebg-preview.png";
import patherametal2 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093345-removebg-preview.png";
import patherametal3 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093405-removebg-preview.png";
import patherametal4 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093424-removebg-preview.png";
import patherametal5 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093442-removebg-preview.png";
import patherametal6 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093500-removebg-preview.png";
import patherametal7 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093548-removebg-preview.png";
import patherametal8 from "../../Assets/EV9/Panthera Metal/Screenshot_2024-05-27_093607-removebg-preview.png";
import Ivory1 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_092837-removebg-preview.png";
import Ivory2 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_092857-removebg-preview.png";
import Ivory3 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_092914-removebg-preview.png";
import Ivory4 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_092939-removebg-preview.png";
import Ivory5 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_093000-removebg-preview.png";
import Ivory6 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_093028-removebg-preview.png";
import Ivory7 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_093048-removebg-preview.png";
import Ivory8 from "../../Assets/EV9/Ivory Silver Gloss/Screenshot_2024-05-27_093115-removebg-preview.png";

export const CarData = [
  {
    id: 1,
    price: "40,789",
    price2: "54,495",
    price3: "57,695",
    price4: "62,595",
    name: "EX",
    name2: "EV6 EX RWD",
    name3: "EV6 GT-LINE RWD",
    name4: "EV6 GT-LINE (E-AWD)",
    _CVE1_CVE2_int_colors: ["#1B1B1B"],
    _CVE1_CVE2_aros_colors: ["#1B1B1B"],
    _CVGL1_CV4GL1_int_colors: ["BLACK & WHITE"],
    _CVGL1_CV4GL1_aros_colors: ["#1B1B1B"],
    _CVGL1_CV4GL1_colors: [
      "#1A30AD",
      "#933531",
      "#1B1B1B",
      // "#666666",
      "#C6C4B7",
    ],
    colors: [
      "#1A30AD",
      // "#34425F",
      // "#7A7B7E",
      "#9C9EA0",
      "#C6C4B7",
      "#F9F9F9",
      "#933531",
      "#1B1B1B",
      // "#CD8700",
      // "#4F5354",
    ],
    Colorsname: [
      "Yacht Blue",
      "Gravity Blue",
      "Moonscape",
      "Steel Gray",
      "Snow White Pearl",
      "Glacier",
      "Runway Red",
      "Aurora Black Pearl",
      "Urban Yellow",
      "Interstellar Gray",
    ],
  },
];

export const SpecificationData = [
  {
    EspecificacionesMecánicas: {
      info1: "Especificaciones Mecánicas",
      pra: "Motor Sincrónico de Imanes Permanentes",
      pra2: "Tipo de tracción RWD",
      pra3: "Motor de tracción trasera de 125 kW con 167 caballos de fuerza & 258 lbs-pies. de par de torsión",
      pra4: "Freno de estacionamiento electrónico (EPB) con retención automática",
      pra5: " Sistema de frenado regenerativo con palancas de control",
    },
    SistemaEléctrico: {
      info2: "Sistema Eléctrico",
      pra: "Tipo de batería - Iones de Litio-Polímero",
      pra2: "Voltaje -(V) 522.7V",
      pra3: "Capacidad de carga - 58 kWh",
      pra4: "Velocidad máxima de operación del vehículo (gobernada electrónicamente - 115 mph)",
      pra5: "Sistema de carga múltiple (400V–800V)",
    },
    Exterior: {
      info3: "Exterior",
      pra: "Aros de 19 pulgadas en ruedas aerodínamicas con acabado en gris oscuro",
      pra2: "Control automático de luces con asistencia de luces LED",
      pra3: "Retrovisor plegable eléctrico con calefacción e indicadore",
      pra4: "Cristal trasero con privacidad y spoiler trasero",
      pra5: "Manijas automática",
      pra6: "Puerta de baúl inteligente con apertura automátic",
      pra7: "Equipo de reparación para ruptura de goma (Tire Mobility Kit) * la goma de repuesta no está incluida",
    },
    Interior: {
      info4: "Interior",
      pra: "Pantalla Panorámica Dual de 12.3 con navegación",
      pra2: "Apple CarPlay® Android Auto™",
      pra3: "Bluetooth® y Conectividad de manos libres",
      pra4: "Llave inteligente con encendido por botón",
      pra5: "Cargador Inalámbrico para teléfonos",
      pra6: "Control automático de temperatura de zona dual",
      pra7: "Asientos delanteros con calefacción",
      pra8: "Asientos delanteros con ventilación",
      pra9: "Asiento del conductor eléctrico",
      pra10: "Materiales de asientos en cuero vegano",
      pra11: "Sistema de Audio Meridian Premium con 14 bocinas",
      pra12: " Cuatro (4) puertos USB con carga rápida",
      pra13: "Toma de corriente de 12V - parte delantera",
      pra14: "Toma de corriente de 12V - parte trasera",
      pra15: "Luces interiores de ambientación tipo LED",
      pra16: "Ventanas eléctricas con subida/bajada automática delantera",
      pra17:
        "Consola central delantera fija con bandeja de almacenamiento en apoyabrazos y portavasos doble",
    },

    KiaDriveWise: {
      info5: "Kia Drive Wise",
      pra: "Asistencia para prevención de colisión frontal (FCA) con detección de peatones (sensor al girar)",
      pra2: "Asistencia para prevención de colisión en punto ciego (BCA)",
      pra3: "Asistencia para prevención de colisión de tráfico cruzado posterior (RCCA)",
      pra4: "Asistencia de retención de carril (LKA) y Asistencia de seguimiento de carril (LFA)",
      pra5: "Alerta de distancia de estacionamiento (PDW) Trasero",
      pra6: "Asistencia de salida segura (SEA)",
      pra7: "Control de crucero inteligente (SCC) con parada y arranque + aprendizaje automático ",
      pra8: "Alerta de ocupante trasero (ROA)",
      pra9: "Sistema de monitoreo a vuelta redonda (SVM)",
      pra10: "Monitor para punto ciego (BVM)",
      pra11: "Asistencia para estacionamiento inteligente remoto",
      pra12: "Asistencia para prevención de colisión al estacionarse- reversa",
    },
    Seguridad: {
      info6: "Seguridad",
      pra: "Sistema avanzado de bolsas de aire duales",
      pra2: "Bolsa de aire para las rodillas del conductor",
      pra3: "Bolsas de aire laterales en los asientos delanteros",
      pra4: "Bolsas de aire laterales tipo cortina",
      pra5: "Cinturones de seguridad de 3 puntos para todas las posiciones del asiento",
      pra6: "Pretensores de cinturones de seguridad (asientos delanteros)",
      pra7: "Sistema de frenos antibloqueo (ABS) con frenos de disco en las 4 ruedas",
      pra9: "Sistema de control de tracción",
      pra10: "Control de estabilidad electrónica",
      pra11: "Sistema de distribución electrónica de frenos (EBD)",
      pra12: "Sistema de asistencia de frenado (BA)",
      pra13: "Control de asistencia de en cuestas (HAC)",
      pra14: "Sistema de monitoreo para la presión de aire en las gomas (TPMS)",
      pra15: "Sistema de anclaje para asiento protector de niños (LATCH)",
      pra16: "Cerraduras de seguridad para niños en las puertas traseras",
      pra17: "Apertura de emergencia interna del baúl",
    },
    Medidas: {
      info7: "Medidas/ capacidades exteriores",
      pra: "Largo 184.3 in.",
      pra2: "Ancho (sin espejos laterales) 74.0 in",
      pra3: "Altura 60.8 in",
      pra4: "Distancia entre ejes 114.2 in",
      pra5: "Alero (delantero/trasero) 33.3 in. / 37.4 in.",
      pra6: "Track (delantero/trasero 64.2 in. / 64.6 in.",
      pra7: "Claridad del piso 6.1 in.",
    },
    Medidascapacidades: {
      info8: "Medidas/ capacidades interiores",
      pra: "Espacio para la cabeza con sunroof (delantero/trasero)",
      pra2: "Espacio para la cabeza sin sunroof (delantero/trasero) 39.0/38.0 in.",
      pra3: " Espacio para las piernas (delantero/trasero) 42.4/39.0 in",
      pra4: " Espacio para los hombros (delantero/trasero) 57.8/55.6 in.",
      pra5: " Espacio para las caderas (delantero/trasero) 54.9/53.2 in",
      pra6: "Volumen de pasajeros 103.0 cu. ft.",
      pra7: "Volumen de carga (asientos traseros levantados/asientos traseros recogidos) 24.4 / 50.2 cu. ft.",
    },
    Medidascapacidadess: {
      info8: "Medidas/ capacidades interiores",
      pra: "Espacio para la cabeza con sunroof (delantero/trasero)",
      pra2: " Espacio para la cabeza sin sunroof (delantero/trasero)",
      pra3: " Espacio para las piernas (delantero/trasero)",
      pra4: " Espacio para los hombros (delantero/trasero)",
      pra5: " Espacio para las caderas (delantero/trasero)",
      pra6: " Volumen de pasajeros",
      pra7: "Volumen de carga (asientos traseros levantados/asientos traseros recogidos)",
    },
    Peso: {
      info9: "Peso",
      pra: "Peso en vacío 4,017 lbs.",
      pra2: "GVWR 5,004 lbs",
      pra3: "Capacidad de remolque con freno - No cuenta con capacidad de remolque",
    },
    MPGe: {
      info10: "MPGe",
      pra: "Ciudad 136",
      pra2: "Autopista 100 ",
      pra3: "Combinado .117",
      pra4: "Autonomía totalmente eléctrica (millas) 232",
    },
  },
];
export const EV9SpecificationData = [
  {
    info1: "Especificaciones mecánicas",
    pra: "Motor Síncrono de Imán Permanente AC",
    pra2: "Tipo de tracción AWD",
    pra3: "Doble motor e-AWD con 379 hp y 516 lb.-ft. de torsión",
    pra4: "Freno de estacionamiento electrónico con retención automática",
    pra5: "Frenado regenerativo con palancas montadas en el volante",
    pra6: "Generador de energía a bordo (V2L)",
  },
  {
    info2: "Sistema Eléctrico",
    pra: "Tipo de batería: Batería de iones de litio",
    pra2: "Voltaje de batería (V): 552V",
    pra3: "Energía de batería (kWh): 99.8 kWh",
    pra4: "Velocidad máxima (mph) (AWD): 115 mph",
    pra5: "Sistema de carga múltiple (400V–800V)",
    pra6: "Tiempo de carga rápida de DC (10-80% a 50 kW mediante equipo de suministro de vehículos eléctrico): Aprox. 83 min.",
    pra7: "Cargador Nivel 3",
  },
  {
    info3: "Exterior",
    pra: "Ruedas de 21 pulgadas estilo aerodinámico con acabado en negro",
    pra2: "Estilo exterior e interior GT-Line",
    pra3: "Luces delanteras LED con control automático de iluminación",
    pra4: "Espejo exterior plegable eléctrico con calefacción y señal de giro integrada",
    pra5: "Cristal de privacidad traseros y alerón trasero",
    pra6: "Mango de puerto con extensión (Auto)",
    pra7: "Puerta trasera eléctrica inteligente",
    pra8: "Techo corredizo eléctrico",
    pra9: "Paquete de remolque",
    pra10: "Kit de movilidad para gomas (no incluye repuesta)",
  },
  {
    info4: "Interior",
    pra: "Pantalla panorámica doble de 12.3 con navegación",
    pra2: "Apple CarPlay® Android Auto™",
    pra3: "Tecnología inalámbrica Bluetooth® con conectividad manos libres",
    pra4: "Llave inteligente con botón de arranque y encendido remoto",
    pra5: "Cargador inalámbrico (teléfono)",
    pra6: "Control de clima automático de dos zonas con ventilación trasera",
    pra7: "Asientos delanteros calefaccionados",
    pra8: "Asientos delanteros ventilados",
    pra9: "Asiento del conductor con memoria",
    pra10: "Materiales de asiento de tela reciclada y cuero vegano",
    pra11: "Paquete de asientos de gamuza GT-Line",
    pra12: "Sistema de audio premium Meridian con 14 altavoces",
    pra13: "Espejo retrovisor completo con HomeLink®",
    pra14: "6 puertos USB de carga rápida",
    pra15: "Puerto Eléctrico de 110V DC — área de carga trasera",
    pra16: "Iluminación ambiental LED interior",
    pra17:
      "Ventana eléctrica con apertura/cierre de un solo toque para el conductor",
    pra18:
      "Consola central de dos niveles con bandeja de almacenamiento frontal inferior",
  },
  {
    info5: "Kia Drive Wise",
    pra: "Asistencia para prevención colisión frontal con detección de peatones, vehículos y ciclistas al girar en intersecciones.",
    pra2: "Asistencia para evitar colisiones en puntos ciegos",
    pra3: "Asistencia para evitar colisiones de tráfico cruzado trasero",
    pra4: "Asistencia para seguir y mantenerse en el carril",
    pra5: "Advertencia de distancia al estacionarse — Reversa",
    pra6: "Kia Drive Wise",
    pra7: "Asistencia de salida segura",
    pra8: "Control de crucero inteligente basado en navegación con Stiop & Go",
    pra9: "Alerta de ocupante trasero",
    pra10: "Monitor de vista envolvente (SVM)",
    pra11: "Monitor de punto de vista ciego",
    pra12: "Asistencia de estacionamiento remoto inteligente ",
    pra13: "Asistencia para evitar colisiones al estacionar — marcha atrás",
    pra14: "Pantalla frontal de realidad aumentada",
  },
  {
    info6: "Seguridad",
    pra: "Bolsas de aire avanzadas frontales duales",
    pra2: "Bolsa de aire para las rodillas del conductor",
    pra3: "Dobles bolsas de aire laterales traseras",
    pra4: "Bolsas de aire de cortina lateral de longitud completa",
    pra5: "Cinturones de seguridad de tres puntos para todos los asientos",
    pra6: "Pretensores de cinturones de seguridad delanteros",
    pra7: "Sistema de frenos antibloqueo (ABS), frenos de disco en las 4 ruedas",
    pra9: "Sistema de Gestión de Estabilidad del Vehículo (VSM)",
    pra10: "Sistema de control de tracción",
    pra11: "Control electrónico de estabilidad",
    pra12: "Distribución electrónica de la fuerza de frenado (EBD)",
    pra13: "Sistema de asistencia de frenado (BAS)",
    pra14: "Control de asistencia para arranque en pendiente (HAC)",
    pra15: "Sistema de monitoreo de presión de las gomas (TPMS)",
    pra16: "Anclajes bajos y correas de amarre para niños (LATCH)",
    pra17: "Seguros de puertas traseras de seguridad para niños",
    pra18: "Botón de apertura de emergencia del baúl",
  },
  {
    info7: "Medidas/ capacidades exteriores",
    pra: "Largo: 197.4 in.",
    pra2: "Ancho (sin los espejos laterales): 77.9 in.",
    pra3: "Alto: 70.1 in.",
    pra4: "Distancia entre ejes: 122.0 in.",
    pra5: "Tracción en las cuatro ruedas (delantero/trasero) AWD: 66.6 / 67.1 in.",
    pra6: "Altura libre del suelo: 7.8 in.",
  },
  {
    info8: "Medidas/ capacidades interiores",
    pra: "Espacio libre con techo corredizo (delantero/trasero): 38.8 / 39.5 in.",
    pra2: "Espacio libre sin techo corredizo (delantero/trasero): 38.8 / 39.5 in.",
    pra3: "Espacio para las piernas (delantero/trasero): 42.8 / 32.0 in.",
    pra4: "Espacio para los hombros (delantero/trasero): 60.0 / 55.0 in.",
    pra5: "Espacio para las caderas (delantero/trasero): 57.9 / 41.9 in.",
    pra6: "Volumen de pasajeros: 160.3 cu.ft.",
    pra7: "Volumen de carga (detrás de la 1ª fila/detrás de la 2ª fila/detrás de la 3ª fila): 81.7/ 43.5/ 20.2 cu.ft.",
    pra8: "Capacidad de pasajeros: 7",
  },
  {
    info9: "Peso",
    pra: "Mínimo peso en vacío: 5,800 lbs.",
    pra2: "Clasificaci쎣n de peso bruto del veh썿culo: 7,099 lbs.",
    pra3: "Capacidad de remolque con freno: 3,500 - 5,000 lbs.",
  },
  {
    info10: "Economía de combustible:",
    pra: "Ciudad (MPGe): 88",
    pra2: "Autopista (MPGe): 72 ",
    pra3: "Combinado (MPGe): 80",
    pra4: "Autonomía eléctrica (millas): 270",
  },
];

export const Separatedata = [
  {
    id: 1,
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 83 66"
        fill="none"
      >
        <path
          d="M76.5 4.5C77.0945 4.5 77.5764 4.5002 77.9931 4.50692C77.9998 4.92365 78 5.40553 78 6V60C78 60.5945 77.9998 61.0764 77.9931 61.4931C77.5764 61.4998 77.0945 61.5 76.5 61.5H6C5.40553 61.5 4.92365 61.4998 4.50692 61.4931C4.5002 61.0764 4.5 60.5945 4.5 60V6C4.5 5.40553 4.5002 4.92365 4.50692 4.50692C4.92365 4.5002 5.40553 4.5 6 4.5H76.5Z"
          stroke="white"
          stroke-width="9"
        />
        <path
          d="M8.25 8.25L38.85 31.2C40.0056 32.0667 40.5833 32.5 41.25 32.5C41.9167 32.5 42.4944 32.0667 43.65 31.2L74.25 8.25"
          stroke="white"
          stroke-width="9"
        />
      </svg>
    ),
    name: "Email",
    // link: "mailto:noreply@kiaevpr.com ",
    link: "mailto:info@kiaevpr.com",
  },
  {
    id: 2,
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 91 90"
        fill="none"
      >
        <path
          d="M72.4233 81.3171C51.8039 101.936 -11.1545 38.9778 9.46471 18.3586L21.9902 5.83269C22.9168 4.90606 24.4693 5.10601 25.1309 6.23718L34.8029 22.7748C35.1918 23.4397 35.1643 24.2687 34.7323 24.9063L27.8662 35.0405C27.4627 35.6359 27.5387 36.4339 28.0473 36.9425L40.9433 49.8386L53.84 62.7339C54.3486 63.2424 55.1466 63.3184 55.742 62.915L65.8746 56.0499C66.5122 55.6179 67.3412 55.5905 68.0061 55.9792L84.5443 65.6508C85.6755 66.3123 85.8755 67.8648 84.9489 68.7914L72.4233 81.3171Z"
          stroke="white"
          stroke-width="9"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    name: "Teléfono",
    link: "tel:939-475-1686",
  },
  {
    id: 3,
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 84 76"
        fill="none"
      >
        <path
          d="M14.4214 52.8838L11.4543 56.2671L14.4214 52.8838ZM29.6667 60.9117L30.8696 56.5754L29.6667 60.9117ZM9.625 70.276L7.50861 74.2473C7.72008 74.36 7.94021 74.4556 8.16691 74.5333L9.625 70.276ZM74.5 32.9754C74.5 40.8277 71.0674 47.1309 65.3878 51.5803C59.6238 56.0958 51.4044 58.7822 42 58.7822V67.7822C53.0302 67.7822 63.3107 64.6404 70.9381 58.6651C78.6499 52.6237 83.5 43.7735 83.5 32.9754H74.5ZM9.5 32.9754C9.5 26.6433 12.7382 20.8939 18.5257 16.5816C24.3457 12.2451 32.6206 9.5 42 9.5V0.5C30.9449 0.5 20.7198 3.72315 13.1484 9.36465C5.5445 15.0303 0.5 23.2686 0.5 32.9754H9.5ZM42 9.5C51.6129 9.5 59.8731 11.7047 65.5914 15.6867C71.1367 19.5482 74.5 25.1917 74.5 32.9754H83.5C83.5 22.1089 78.5805 13.7646 70.7345 8.301C63.0614 2.95782 52.8217 0.5 42 0.5V9.5ZM17.3884 49.5005C12.406 45.1312 9.5 38.9928 9.5 32.9754H0.5C0.5 41.834 4.71906 50.3606 11.4543 56.2671L17.3884 49.5005ZM42 58.7822C38.4328 58.7822 34.9743 57.7142 30.8696 56.5754L28.4637 65.2479C32.0743 66.2495 36.9182 67.7822 42 67.7822V58.7822ZM30.8696 56.5754C28.7602 55.9902 26.9822 56.815 26.1713 57.258C25.2366 57.7687 24.3695 58.4602 23.6781 59.0478C22.9625 59.6558 22.1804 60.3763 21.4626 61.0284C20.7124 61.71 19.9655 62.3794 19.1901 63.0184C15.8139 65.8004 13.3254 66.7868 11.0831 66.0188L8.16691 74.5333C15.3459 76.9921 21.3755 72.8794 24.9134 69.9641C25.8665 69.1787 26.7479 68.3864 27.5148 67.6896C28.3141 66.9634 28.9379 66.3888 29.5061 65.9059C30.0984 65.4026 30.3928 65.2072 30.4867 65.156C30.7043 65.0371 29.8217 65.6246 28.4637 65.2479L30.8696 56.5754ZM11.7414 66.3048C12.6714 66.8004 13.2169 67.5757 13.4756 68.2344C13.6993 68.8039 13.6935 69.2298 13.6919 69.3094C13.6892 69.4412 13.6817 69.259 13.891 68.5942C14.2874 67.3351 15.0351 65.6223 15.9483 63.5741C16.7943 61.6765 17.7949 59.4639 18.4272 57.6184C18.7371 56.714 19.0594 55.6183 19.1688 54.5376C19.2431 53.8038 19.4332 51.2937 17.3884 49.5005L11.4543 56.2671C10.6502 55.5619 10.3666 54.7401 10.2717 54.2958C10.2238 54.0715 10.2127 53.8986 10.2103 53.8002C10.2078 53.6998 10.2137 53.64 10.2146 53.6311C10.2155 53.6223 10.2061 53.7095 10.1527 53.9186C10.1015 54.1193 10.0238 54.3783 9.91312 54.7012C9.44293 56.0735 8.64747 57.8474 7.72819 59.9093C6.87606 61.8207 5.88925 64.0404 5.30648 65.8913C5.02619 66.7815 4.71791 67.9486 4.69377 69.1247C4.67357 70.1088 4.85552 72.8334 7.50861 74.2473L11.7414 66.3048Z"
          fill="white"
        />
      </svg>
    ),
    name: "Chat",
  },
];

export const variant = [
  { name: "EV6", pathname: "/Galeria" },
  { name: "EV9", pathname: "/Galeria/EV9" },
];
export const EV9Modeldata = [
  {
    id: 1,
    img: cardimg1,
    // name: "Model CVE1-23",
    name: "EV9 GT-LINE",
    price: "$79,795",
    vorte: "552V",
    km: "99.8 kWh",
    rwd: "AWD",
    icon: cardicon1,
    icon2: cardicon2,
    icon3: cardicon3,
    MPGe: 270,
    _CVE1_CVE2_int_colors: ["#1B1B1B"],
    _CVE1_CVE2_aros_colors: ["#1B1B1B"],
    _CVGL1_CV4GL1_int_colors: ["BLACK & WHITE"],
    _CVGL1_CV4GL1_aros_colors: ["#1B1B1B"],
    _CVGL1_CV4GL1_colors: [
      "#0161A5",
      "#DEDFDF",
      "#A9A7A4",
      "#6A7977",
      "#8A8987",
      "#2B2B2B",
      "#373737",
    ],

    colors: [
      "#0161A5",
      "#DEDFDF",
      "#A9A7A4",
      "#6A7977",
      "#D0D0CC",
      "#2B2B2B",
      "#373737",
      "#AFB0B1",
    ],
    Colorsname: [
      "Ocean Blue Gloss",
      "Snow White Pearl",
      "Pebble Gray",
      "Iceberg Green",
      "Ivory Matte Silver",
      "Aurora Black Pearl",
      "Panthera Metal",
      "Ivory Silver Gloss",
    ],
  },
];

export const MenuData = [
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.71 12.7101C16.6904 11.9388 17.406 10.881 17.7572 9.68407C18.1085 8.48709 18.0779 7.21039 17.6698 6.03159C17.2617 4.85279 16.4963 3.83052 15.4801 3.10698C14.4639 2.38344 13.2474 1.99463 12 1.99463C10.7525 1.99463 9.53611 2.38344 8.51993 3.10698C7.50374 3.83052 6.73834 4.85279 6.33021 6.03159C5.92208 7.21039 5.89151 8.48709 6.24276 9.68407C6.59401 10.881 7.3096 11.9388 8.29 12.7101C6.61007 13.3832 5.14428 14.4995 4.04889 15.94C2.95349 17.3806 2.26956 19.0914 2.07 20.8901C2.05555 21.0214 2.06711 21.1543 2.10402 21.2812C2.14093 21.408 2.20246 21.5264 2.28511 21.6294C2.45202 21.8376 2.69478 21.971 2.96 22.0001C3.22521 22.0293 3.49116 21.9519 3.69932 21.785C3.90749 21.6181 4.04082 21.3753 4.07 21.1101C4.28958 19.1553 5.22168 17.3499 6.68822 16.0389C8.15475 14.7279 10.0529 14.0032 12.02 14.0032C13.9871 14.0032 15.8852 14.7279 17.3518 16.0389C18.8183 17.3499 19.7504 19.1553 19.97 21.1101C19.9972 21.3558 20.1144 21.5828 20.2991 21.7471C20.4838 21.9115 20.7228 22.0016 20.97 22.0001H21.08C21.3421 21.97 21.5817 21.8374 21.7466 21.6314C21.9114 21.4253 21.9881 21.1625 21.96 20.9001C21.7595 19.0963 21.0719 17.3811 19.9708 15.9383C18.8698 14.4955 17.3969 13.3796 15.71 12.7101V12.7101ZM12 12.0001C11.2089 12.0001 10.4355 11.7655 9.77772 11.326C9.11992 10.8865 8.60723 10.2618 8.30448 9.53086C8.00173 8.79995 7.92251 7.99569 8.07686 7.21976C8.2312 6.44384 8.61216 5.73111 9.17157 5.1717C9.73098 4.61229 10.4437 4.23132 11.2196 4.07698C11.9956 3.92264 12.7998 4.00186 13.5307 4.30461C14.2616 4.60736 14.8863 5.12005 15.3259 5.77784C15.7654 6.43564 16 7.209 16 8.00012C16 9.06099 15.5786 10.0784 14.8284 10.8286C14.0783 11.5787 13.0609 12.0001 12 12.0001Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Detalles del perfil",
    link: "/Perfil/MyProfile",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 10H8C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 8.73478 8.89464 8.48043 8.70711 8.29289C8.51957 8.10536 8.26522 8 8 8H5C4.73478 8 4.48043 8.10536 4.29289 8.29289C4.10536 8.48043 4 8.73478 4 9C4 9.26522 4.10536 9.51957 4.29289 9.70711C4.48043 9.89464 4.73478 10 5 10ZM17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V12C0 12.7956 0.316071 13.5587 0.87868 14.1213C1.44129 14.6839 2.20435 15 3 15H17C17.7956 15 18.5587 14.6839 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 12C18 12.2652 17.8946 12.5196 17.7071 12.7071C17.5196 12.8946 17.2652 13 17 13H3C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12V6H18V12ZM18 4H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V4Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Método de pago",
    link: "/Perfil/MyCard",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 5.82245C20.0048 5.75921 20.0048 5.69569 20 5.63245L18 0.632454C17.9219 0.43481 17.7828 0.26719 17.603 0.153909C17.4232 0.0406286 17.212 -0.0124219 17 0.0024534H3C2.79972 0.00225952 2.604 0.0622081 2.43818 0.174534C2.27237 0.28686 2.1441 0.446388 2.07 0.632454L0.0699999 5.63245C0.0651796 5.69569 0.0651796 5.75921 0.0699999 5.82245C0.0367708 5.87812 0.0131096 5.93896 0 6.00245C0.0111306 6.69369 0.201226 7.37025 0.551745 7.96613C0.902263 8.56201 1.40124 9.05688 2 9.40245V19.0025C2 19.2677 2.10536 19.522 2.29289 19.7096C2.48043 19.8971 2.73478 20.0025 3 20.0025H17C17.2652 20.0025 17.5196 19.8971 17.7071 19.7096C17.8946 19.522 18 19.2677 18 19.0025V9.44245C18.6046 9.09343 19.1072 8.59228 19.4581 7.98879C19.809 7.38531 19.9958 6.70051 20 6.00245C20.0094 5.94282 20.0094 5.88209 20 5.82245ZM11 18.0025H9V14.0025H11V18.0025ZM16 18.0025H13V13.0025C13 12.7372 12.8946 12.4829 12.7071 12.2953C12.5196 12.1078 12.2652 12.0025 12 12.0025H8C7.73478 12.0025 7.48043 12.1078 7.29289 12.2953C7.10536 12.4829 7 12.7372 7 13.0025V18.0025H4V10.0025C4.56947 9.99924 5.13169 9.87447 5.64905 9.63648C6.16642 9.39849 6.627 9.05278 7 8.62245C7.37537 9.04808 7.83701 9.38896 8.35425 9.62245C8.87149 9.85595 9.4325 9.9767 10 9.9767C10.5675 9.9767 11.1285 9.85595 11.6458 9.62245C12.163 9.38896 12.6246 9.04808 13 8.62245C13.373 9.05278 13.8336 9.39849 14.3509 9.63648C14.8683 9.87447 15.4305 9.99924 16 10.0025V18.0025ZM16 8.00245C15.4696 8.00245 14.9609 7.79174 14.5858 7.41667C14.2107 7.04159 14 6.53289 14 6.00245C14 5.73724 13.8946 5.48288 13.7071 5.29535C13.5196 5.10781 13.2652 5.00245 13 5.00245C12.7348 5.00245 12.4804 5.10781 12.2929 5.29535C12.1054 5.48288 12 5.73724 12 6.00245C12 6.53289 11.7893 7.04159 11.4142 7.41667C11.0391 7.79174 10.5304 8.00245 10 8.00245C9.46957 8.00245 8.96086 7.79174 8.58579 7.41667C8.21071 7.04159 8 6.53289 8 6.00245C8 5.73724 7.89464 5.48288 7.70711 5.29535C7.51957 5.10781 7.26522 5.00245 7 5.00245C6.73478 5.00245 6.48043 5.10781 6.29289 5.29535C6.10536 5.48288 6 5.73724 6 6.00245C6.00985 6.2651 5.96787 6.52711 5.87646 6.77353C5.78505 7.01995 5.646 7.24595 5.46725 7.43863C5.28849 7.63132 5.07354 7.7869 4.83466 7.89651C4.59578 8.00612 4.33764 8.0676 4.075 8.07745C3.54457 8.09734 3.02796 7.90571 2.63882 7.5447C2.44614 7.36595 2.29055 7.15099 2.18094 6.91211C2.07133 6.67323 2.00985 6.4151 2 6.15245L3.68 2.00245H16.32L18 6.15245C17.9621 6.65647 17.7348 7.12744 17.3637 7.47066C16.9927 7.81388 16.5054 8.00388 16 8.00245Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Estatus de orden",
    link: "/Perfil/History",
  },
  {
    img: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.71 6.29C13.617 6.19627 13.5064 6.12188 13.3846 6.07111C13.2627 6.02034 13.132 5.9942 13 5.9942C12.868 5.9942 12.7373 6.02034 12.6154 6.07111C12.4936 6.12188 12.383 6.19627 12.29 6.29L10 8.59L7.71 6.29C7.5217 6.1017 7.2663 5.99591 7 5.99591C6.7337 5.99591 6.4783 6.1017 6.29 6.29C6.1017 6.4783 5.99591 6.7337 5.99591 7C5.99591 7.2663 6.1017 7.5217 6.29 7.71L8.59 10L6.29 12.29C6.19627 12.383 6.12188 12.4936 6.07111 12.6154C6.02034 12.7373 5.9942 12.868 5.9942 13C5.9942 13.132 6.02034 13.2627 6.07111 13.3846C6.12188 13.5064 6.19627 13.617 6.29 13.71C6.38296 13.8037 6.49356 13.8781 6.61542 13.9289C6.73728 13.9797 6.86799 14.0058 7 14.0058C7.13201 14.0058 7.26272 13.9797 7.38458 13.9289C7.50644 13.8781 7.61704 13.8037 7.71 13.71L10 11.41L12.29 13.71C12.383 13.8037 12.4936 13.8781 12.6154 13.9289C12.7373 13.9797 12.868 14.0058 13 14.0058C13.132 14.0058 13.2627 13.9797 13.3846 13.9289C13.5064 13.8781 13.617 13.8037 13.71 13.71C13.8037 13.617 13.8781 13.5064 13.9289 13.3846C13.9797 13.2627 14.0058 13.132 14.0058 13C14.0058 12.868 13.9797 12.7373 13.9289 12.6154C13.8781 12.4936 13.8037 12.383 13.71 12.29L11.41 10L13.71 7.71C13.8037 7.61704 13.8781 7.50644 13.9289 7.38458C13.9797 7.26272 14.0058 7.13201 14.0058 7C14.0058 6.86799 13.9797 6.73728 13.9289 6.61542C13.8781 6.49356 13.8037 6.38296 13.71 6.29V6.29ZM17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V17Z"
          fill="#D40000"
        />
      </svg>
    ),
    text: "Pedido cancelado",
    link: "/Perfil/CanceledOrders",
  },
  {
    img: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4998 16.0001C10.4998 15.1717 11.1714 14.5001 11.9998 14.5001C12.8282 14.5001 13.4998 15.1717 13.4998 16.0001C13.4998 16.8285 12.8282 17.5001 11.9998 17.5001C11.1714 17.5001 10.4998 16.8285 10.4998 16.0001Z"
          fill="#ED1B24"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62147 10.5973L7.30603 7.75828C7.26559 7.3943 7.26559 7.02696 7.30603 6.66298L7.32879 6.45809C7.57028 4.2847 9.27888 2.56504 11.4507 2.30953C11.8155 2.26661 12.1841 2.26661 12.5489 2.30953C14.7207 2.56504 16.4293 4.2847 16.6708 6.45809L16.6936 6.66298C16.734 7.02696 16.734 7.3943 16.6936 7.75828L16.3781 10.5972L17.0647 10.6521C18.1474 10.7385 19.0316 11.5524 19.2071 12.6243C19.5731 14.8599 19.5731 17.1403 19.2071 19.3759C19.0316 20.4478 18.1474 21.2617 17.0647 21.3482L15.5686 21.4676C13.1932 21.6572 10.8065 21.6572 8.4311 21.4676L6.93497 21.3482C5.85224 21.2617 4.96814 20.4478 4.79262 19.3759C4.42655 17.1403 4.42655 14.8599 4.79262 12.6243C4.96814 11.5524 5.85224 10.7385 6.93497 10.6521L7.62147 10.5973ZM11.6259 3.79926C11.8743 3.77004 12.1253 3.77004 12.3737 3.79926C13.8523 3.97322 15.0156 5.14402 15.18 6.62373L15.2027 6.82863C15.2309 7.08252 15.2309 7.33874 15.2027 7.59263L14.8816 10.4831C12.9624 10.3595 11.0372 10.3595 9.11801 10.4831L8.79685 7.59263C8.76864 7.33875 8.76864 7.08252 8.79685 6.82863L8.81962 6.62373C8.98403 5.14402 10.1473 3.97322 11.6259 3.79926ZM15.4492 12.0279C13.1533 11.8446 10.8464 11.8446 8.55047 12.0279L7.05434 12.1473C6.65941 12.1788 6.33693 12.4757 6.27291 12.8667C5.93312 14.9418 5.93312 17.0584 6.27291 19.1335C6.33693 19.5245 6.65941 19.8214 7.05434 19.8529L8.55047 19.9723C10.8464 20.1556 13.1533 20.1556 15.4492 19.9723L16.9454 19.8529C17.3403 19.8214 17.6628 19.5245 17.7268 19.1335C18.0666 17.0584 18.0666 14.9418 17.7268 12.8667C17.6628 12.4757 17.3403 12.1788 16.9454 12.1473L15.4492 12.0279Z"
          fill="#ED1B24"
        />
      </svg>
    ),
    text: "Cambiar contraseña",
    link: "/Perfil/ChangePassword",
  },
];

export const imagesdata = [
  {
    colorcode: "#0161A5",
    images: [
      oceanblue1,
      oceanblue2,
      oceanblue3,
      oceanblue4,
      oceanblue5,
      oceanblue6,
      oceanblue7,
      oceanblue8,
    ],
  },
  {
    colorcode: "#DEDFDF",
    images: [
      snowwhite1,
      snowwhite2,
      snowwhite3,
      snowwhite4,
      snowwhite5,
      snowwhite6,
      snowwhite7,
      snowwhite8,
    ],
  },
  {
    colorcode: "#A9A7A4",
    images: [
      puplegray1,
      puplegray2,
      puplegray3,
      puplegray4,
      puplegray5,
      puplegray6,
      puplegray7,
      puplegray8,
    ],
  },
  {
    colorcode: "#6A7977",
    images: [
      icegreen1,
      icegreen2,
      icegreen3,
      icegreen4,
      icegreen5,
      icegreen6,
      icegreen7,
      icegreen8,
    ],
  },
  {
    colorcode: "#D0D0CC",
    images: [
      silvermatte1,
      silvermatte2,
      silvermatte3,
      silvermatte4,
      silvermatte5,
      silvermatte6,
      silvermatte7,
      silvermatte8,
    ],
  },
  {
    colorcode: "#2B2B2B",
    images: [
      arorablack1,
      arorablack2,
      arorablack3,
      arorablack4,
      arorablack5,
      arorablack6,
      arorablack7,
      arorablack8,
    ],
  },
  {
    colorcode: "#373737",
    images: [
      patherametal1,
      patherametal2,
      patherametal3,
      patherametal4,
      patherametal5,
      patherametal6,
      patherametal7,
      patherametal8,
    ],
  },
  {
    colorcode: "#AFB0B1",
    images: [Ivory1, Ivory2, Ivory3, Ivory4, Ivory5, Ivory6, Ivory7, Ivory8],
  },
];
